import request from '@core/request'


// 海外-内容管理/新闻列表
// 海外臻选媒体

export function ydylListMedia(data) {
  return request({
    baseURL: `${process.env.VUE_APP_AGGREGATE_API}`,
    url: '/api/ydylmedia/listMedia',
    method: 'post',
    data,
  })
}
